import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux';
import { server_connection } from 'config';
import ReactDropzone from 'react-dropzone';
import * as Actions from './../store/actions'
import { bindActionCreators } from 'redux';

const styles = theme => ({
});


class AvatarUpload extends Component {
    onDrop = (files) => {
        const data = new FormData();
        files.forEach(file => {
            data.append('Avatar', file);
            data.append('old_asset_id', this.props.old_asset_id)
        });

        data.append('auth_id', this.props.auth_id)
        this.props.uploadAvatar(data)
    }

    render() {
        const { auth_id } = this.props

        return (
            <div >
                <h3>Change Avatar</h3>
                <ReactDropzone
                    onDrop={this.onDrop} >
                    Drop profile pic here
                </ReactDropzone>
            </div>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        uploadAvatar: Actions.uploadAvatar
    }, dispatch);
}

function mapStateToProps({  }) {
    return {

    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(AvatarUpload)));
// export default AvatarUpload;


// WEBPACK FOOTER //
// src/main/content/dashboard/components/AvatarUpload.js